module.exports = __webpack_public_path__ + "img/Weapon_257.49bfd427.png";